import {
  AutoFixHighOutlined as AutoFixHighOutlinedIcon,
  VisibilityOutlined as VisibilityOutlinedIcon
} from '@mui/icons-material'
import DataTable from '../../components/DataTable'
import SectionCard from '../../components/SectionCard'

const RecipeStatusPill = ({ hasRecipe, isActive, label }) => {
  const toneClassName = !hasRecipe
    ? 'border-slate-200 bg-slate-100 text-slate-600'
    : isActive
      ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
      : 'border-amber-200 bg-amber-50 text-amber-700'

  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium ${toneClassName}`}>
      {label}
    </span>
  )
}

const RecipeListView = ({ rows, loading, searchValue, onSearchChange, onCreate, onOpenReview }) => (
  <SectionCard
    title='Recetas'
    description='Explora las recetas ya creadas y abre una en modal para revisarla o construir una nueva versión.'
  >
    <div className='space-y-4'>
      <div className='flex flex-col gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 lg:flex-row lg:items-center lg:justify-between'>
        <div className='w-full lg:max-w-md'>
          <label className='mb-1 block text-xs font-semibold text-slate-700'>Buscar receta creada</label>
          <input
            type='search'
            value={searchValue}
            onChange={event => onSearchChange(event.target.value)}
            placeholder='Buscar por ID, SKU o producto'
            className='w-full rounded-lg border border-gray-300 px-3 py-2 text-sm'
          />
        </div>

        <button
          type='button'
          onClick={onCreate}
          className='inline-flex items-center justify-center gap-1.5 rounded-lg bg-accent2 px-4 py-2 text-sm font-semibold text-white transition hover:bg-accent2/90'
        >
          <AutoFixHighOutlinedIcon style={{ fontSize: '1rem' }} />
          Construir receta
        </button>
      </div>

      <DataTable
        columns={['Receta', 'SKU', 'Estado', 'Versión', 'Rinde', 'Acciones']}
        rows={rows}
        loading={loading}
        emptyText='Aún no hay recetas creadas. Usa "Construir receta" para registrar la primera.'
        renderRow={row => (
          <>
            <td className='px-4 py-3 align-top'>
              <div className='font-semibold text-slate-900'>{row.name}</div>
              <div className='mt-1 text-xs text-slate-500'>Receta #{row.recipeId}</div>
              <div className='mt-1 text-xs text-slate-500'>{row.unitContext}</div>
            </td>
            <td className='px-4 py-3 align-top text-slate-700'>{row.sku || 'SIN-SKU'}</td>
            <td className='px-4 py-3 align-top'>
              <RecipeStatusPill hasRecipe={row.hasRecipe} isActive={row.isActive} label={row.statusLabel} />
            </td>
            <td className='px-4 py-3 align-top text-slate-700'>{row.versionLabel}</td>
            <td className='px-4 py-3 align-top text-slate-700'>{row.yieldLabel}</td>
            <td className='px-4 py-3 align-top'>
              <div className='flex justify-end'>
                <button
                  type='button'
                  onClick={() => onOpenReview(row.id)}
                  className='inline-flex items-center gap-1 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50'
                >
                  <VisibilityOutlinedIcon style={{ fontSize: '0.9rem' }} />
                  Ver receta
                </button>
              </div>
            </td>
          </>
        )}
      />
    </div>
  </SectionCard>
)

export default RecipeListView
